import { render, staticRenderFns } from "./BankSlipForm.vue?vue&type=template&id=6becb4d8&scoped=true&"
import script from "./BankSlipForm.vue?vue&type=script&lang=ts&"
export * from "./BankSlipForm.vue?vue&type=script&lang=ts&"
import style0 from "./BankSlipForm.vue?vue&type=style&index=0&id=6becb4d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6becb4d8",
  null
  
)

export default component.exports